import TrackingProvider from './TrackingProvider';
import { SportRadarEvents } from './enums';

type SportRadarEvent = `${SportRadarEvents}`;

class SportRadar extends TrackingProvider {
    static get registeredEvents() {
        return window.SportRadarEvents || {};
    }

    initialize(trackingIds: string) {
        const ids = this.extractCleanTrackingIds(trackingIds);

        if (!this.isActive && ids.length > 0) {
            this._trackingIds = ids;
            window.srtmCommands = window.srtmCommands || [];
            const script = document.createElement('script');
            script.setAttribute('data-srtmn', 'srtmCommands');
            this.loadScript(`https://tm.ads.sportradar.com/dist/tag-manager.js?id=${this.firstTrackingId}`, script);
            this._active = true;
        }

        return this;
    }

    triggerAll() {
        this.triggerRegistrationIsStarted();
        this.triggerRegistrationIsCompleted();
        this.triggerLoggedIn();
        this.triggerDepositEvent();
        this.debug('SR.triggerAll:', SportRadar.registeredEvents);
    }

    triggerRegistrationIsStarted() {
        const registrationForm = document.getElementById('register-form');
        if (!registrationForm) {
            return;
        }

        // Send an event only once, not on every focus
        let eventPushed = false;
        registrationForm.querySelector('input[name="password"]').addEventListener('focus', () => {
            if (!eventPushed) {
                this.pushRegistrationStartedEvent();
            }

            eventPushed = true;
        });
    }

    triggerRegistrationIsCompleted() {
        if (!this.checkIfEventKeyExists(SportRadarEvents.Registration)) {
            return;
        }

        this.pushRegistrationCompletedEvent(this.getRegisteredEventData(SportRadarEvents.Registration));
    }

    triggerLoggedIn() {
        if (!this.checkIfEventKeyExists(SportRadarEvents.Login)) {
            return;
        }

        this.pushLoggedInEvent(this.getRegisteredEventData(SportRadarEvents.Login));
    }

    triggerDepositEvent() {
        if (!this.checkIfEventKeyExists(SportRadarEvents.Deposit)) {
            return;
        }

        this.pushDepositEvent(this.getRegisteredEventData(SportRadarEvents.Deposit));
    }

    pushEvent = (event: SportRadarEvent, payload: object) => {
        window.srtmCommands.push({ event, payload });
    };

    pushRegistrationStartedEvent() {
        this.pushEvent(SportRadarEvents.Registration, { action: 'start' });
    }

    pushRegistrationCompletedEvent(userId: string) {
        this.pushEvent(SportRadarEvents.Registration, { action: 'complete', userId });
    }

    pushLoggedInEvent(userId: string) {
        this.pushEvent(SportRadarEvents.Login, { action: 'complete', userId });
    }

    pushDepositEvent(data: object) {
        this.pushEvent(SportRadarEvents.Deposit, { action: 'created', ...data });
    }

    checkIfEventKeyExists = (key: SportRadarEvent) => typeof SportRadar.registeredEvents[key] !== 'undefined';

    getRegisteredEventData = (key: SportRadarEvent) => SportRadar.registeredEvents[key];
}

export default new SportRadar().initialize(process.env.MIX_SPORTSRADAR_ID);
